import {

    Box

} from "@mui/material";

import { Navigate } from "react-router-dom";

import useAuth from "../hooks/useAuth";

import LoginForm from "../components/auth/LoginForm";

export default function Login() {

    const {

        user

    } = useAuth();

    if (user)

        return <Navigate

            to="/"

            replace

        />;

    return (

        <Box

            sx={{

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                height: "100vh",

                background:

                    "#F4F7FC"

            }}

        >

            <LoginForm />

        </Box>

    );

}